<template>
  <div>
  <van-field
    readonly
    clickable
    name="picker"
    :label-width="labelWidth"
    :value="valuelabel"
    :label="label"
    :placeholder="placeholder"
    @click="open = true"
  />
  <van-popup v-model="open" :position="position">
    <van-picker
      show-toolbar
      :columns="columns"
      @confirm="onConfirm"
      @cancel="open = false"
    />
  </van-popup>
  </div>
</template>

<script>
import {getDicts, getDictLabel} from '@/utils/dicts'
export default {
  	name: 'choice',

  	props: {
  		value: {
  			type: [String, Number],
  			default: ''
  		},
  		placeholder: {
  			type: [String, Number],
  			default: '请选择'
  		},
    labelWidth: {
      type: Number,
      default: 100
    },
    position: {
      type: String,
      default: 'bottom'
    },
  		disabled: {
  			type: Boolean,
  			default: false
  		},

  		type: {
  			type: String,
  			default: ''
  		},

  		label: {
  			type: String,
  			default: 'name'
  		},

  		select: {
  			type: Function,
  			default: null
  		},
  		carryParam: [String, Number, Object],
  		confirmText: {
  			type: String,
  			default: ''
  		}
  	},
  	data () {
  		return {
  			dialogType: '',
        localValue:null,
      valuelabel: null,
  			open: false,
  			columns: [],
      dicts: []

  		}
  	},
  	computed: {
  		// okText() {
  		// 	return this.confirmText || t("uni-popup.ok")
  		// },
  		// closeText() {
  		// 	return this.cancelText || t("uni-popup.cancel")
  		// },
  		// placeholderText() {
  		// 	return this.placeholder || t("uni-popup.placeholder")
  		// },
  		// titleText() {
  		// 	return this.title || t("uni-popup.title")
  		// }
  	},
  	watch: {
  		type (val) {
      this.type = val
  			this.showDict()
  		},

  		value (val) {
  			this.localValue = val
  			this.showDict()
  		}
  	},
  	created () {
  		// 对话框遮罩不可点击

  		this.showDict()
  		// this.popup.closeMask()
  	},
  	mounted () {
  		this.focus = true
  	},
  	methods: {
  		showDict () {
      this.dicts = getDicts(this.type)
      // console.log('获取dicts:', this.dicts)
      this.columns = []
      this.dicts.forEach(item => {
        this.columns.push(item.dictLabel)
      })
      if (this.localValue) {
        for (const d of this.dicts) {
          if (this.value == d.dictValue) {
            // this.value = d.dictValue
            this.valuelabel = d.dictLabel
          }
        }
      }
    },
    onConfirm (value) {
      for (const d of this.dicts) {
        if (value == d.dictLabel) {
          this.localValue = d.dictValue
          this.valuelabel = d.dictLabel
        }
      }
      this.open = false
      console.log('confim', value, this.value, this.select)
      this.$emit('input', this.localValue)

      this.$emit('select', this.localValue)
    }
  	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Dict/choice.vue